import httpRequest from 'httpRequest'
import {
    LocationIntegrationContract,
    OnlineIntegrationLocationContract,
    OnlineOrderIntegrationConfigurationContract,
} from 'models'
import { IntegrationContract } from 'models/IntegrationContract'
import { IntegrationsType } from 'constant/integrations'

const integrationService = {
    getAllIntegrations(type: IntegrationsType) {
        return httpRequest.get<IntegrationContract[]>(`/global/integrations`, {
            params: { type },
        })
    },
    getIntegration(id: string) {
        return httpRequest.get<IntegrationContract>(
            `/global/integrations/${id}`,
        )
    },
    getLocationIntegrations() {
        return httpRequest.get<LocationIntegrationContract[]>(
            '/integrations',
            {},
        )
    },
    getLocationIntegration(id: string) {
        return httpRequest.get<LocationIntegrationContract>(
            `/integrations/${id}`,
            {},
        )
    },
    getLocationOrderIntegration(integrationId: string) {
        return httpRequest.get<LocationIntegrationContract>(
            `/integrations/${integrationId}`,
            {},
        )
    },
    getLocationOrderIntegrations() {
        return httpRequest.get<LocationIntegrationContract[]>(
            `/integrations`,
            {},
        )
    },
    addIntegration(id: string, settings: any) {
        return httpRequest.post(`/integrations/${id}`, settings)
    },
    updateIntegration(id: string, settings: any) {
        return httpRequest.put(`/integrations/${id}`, settings)
    },
    addOrderChannelIntegration(id: string, settings: any) {
        return httpRequest.post(`/integrations/${id}`, settings)
    },
    updateOrderChannelIntegration(
        id: string,
        settings: OnlineOrderIntegrationConfigurationContract,
    ) {
        return httpRequest.put(`/integrations/online-locations/${id}`, settings)
    },
    deleteIntegration(id: string) {
        return httpRequest.delete(`/integrations/${id}`)
    },
    deleteOrderChannelIntegration(id: string) {
        return httpRequest.delete(`/integrations/${id}`)
    },
    syncToHubRise() {
        return httpRequest.get('/integrations/sync/hubrise')
    },
    syncToDeliverect() {
        return httpRequest.get('/integrations/sync/deliverect')
    },
    syncToMenuLive() {
        return httpRequest.get('/integrations/sync/menulive')
    },
    getOnlineLocations(integrationId: number) {
        return httpRequest.get<OnlineIntegrationLocationContract[]>(
            '/integrations/online-locations/' + integrationId,
        )
    },
    getOOIUrl() {
        return httpRequest.get<string>('/integrations/ooi-url')
    },
    getMenuLiveUrl() {
        return httpRequest.get<string>('/integrations/menulive-url')
    },
    getMenuLiveAuthorizeCode() {
        return httpRequest.post<string>('/integrations/menulive/auth')
    },
    checkUsingOnlineOrderIntegration() {
        return httpRequest.get<boolean>(
            '/integrations/use-online-order-integration',
        )
    },
}

export default integrationService
